import unionBy from "lodash/unionBy";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { SimpleAxnWorkflow } from "@idw-types/data/reference-data/axn";
import { sortStrings } from "./string-util";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { toObject } from "@utils/object-util";
import { AxnRpService } from "@idw-types/data/axn-rp-service";
import cloneDeep from "lodash/cloneDeep";

export const injectTemporaryWorkflowOption = (workflowName: string): SelectOption => {
    return { value: '', label: workflowName };
};

export const getActiveRelyingPartyWorkflowOptions = (
    simpleAxnWorkflows: Array<SimpleAxnWorkflow>,
    simpleAxnAdminWorkflows: Array<SimpleAxnWorkflow>,
    relyingPartyID: string,
    workflowName: string
) => {
    // puts all axn admin workflows into axn workflows array - replacing any object in the axn workflow array with
    // an object from the axn admin workflows array if the ids match
    const unionedWorkflows = unionBy(simpleAxnAdminWorkflows, simpleAxnWorkflows, 'id');
    const activeRelyingPartyWorkflowOptions = unionedWorkflows.filter(simpleAxnWorkflow => {
        return simpleAxnWorkflow.status === EntityStatusTypes.ACTIVE && simpleAxnWorkflow.relyingPartyID === relyingPartyID;
    }).map(simpleAxnWorkflow => {
        return { label: simpleAxnWorkflow.name, value: simpleAxnWorkflow.id }
    });

    if (workflowName) {
        activeRelyingPartyWorkflowOptions.push(injectTemporaryWorkflowOption(workflowName));
    }

    return activeRelyingPartyWorkflowOptions.sort((a, b) => sortStrings(a.label, b.label));
};

export const getUpdatedAxnRpServices = (workflowRpServices: Array<FormattedRpServiceConfiguration>, axnRPServices: Array<AxnRpService>) => {
    const rpServiceConfigurationsMap = toObject<FormattedRpServiceConfiguration>(workflowRpServices, 'id');

    let hasAtLeastOneRpServiceUpdated = false;
    const updatedRpServices = axnRPServices.map(rpService => {
        const targetRpService = rpServiceConfigurationsMap[rpService.id];
        if (targetRpService
            && (targetRpService.serviceName !== rpService.serviceName
                || targetRpService.status !== rpService.status
                || targetRpService.apiKey !== rpService.apiKey)
        ) {
            hasAtLeastOneRpServiceUpdated = true;

            return {
                ...rpService,
                serviceName: targetRpService.serviceName,
                status: targetRpService.status,
                apiKey: targetRpService.apiKey
            }
        }

        return rpService;
    });

    return {
        hasAtLeastOneRpServiceUpdated,
        updatedRpServices
    };
}


export const addNotDeployedWorkflowServicesToAxnRpServices = (workflowRpServices: Array<FormattedRpServiceConfiguration>, axnRPServices: Array<AxnRpService>): Array<AxnRpService> => {
    const updatedAxnRpServices = cloneDeep(axnRPServices);

    const axnRpServicesMap = toObject<AxnRpService>(updatedAxnRpServices, 'id');
    workflowRpServices.forEach(workflowService => {
        if (!axnRpServicesMap[workflowService.id]) {
            const { apiKey, id, serviceName, status, relyingParty } = workflowService;
                updatedAxnRpServices.push({
                    apiKey,
                    id,
                    relyingPartyID: relyingParty.id,
                    serviceName,
                    status
                });
            }
    });

    return updatedAxnRpServices;
}
